/**
 * String utility functions
 */
const StrUtil = {
	/**
	 * Filter-out non-allowed characters from str
	 * @param str - Input string to filter
	 * @param allowed - String containing allowed characters
	 * @returns Filtered string containing only allowed characters
	 */
	onlyTheseChars(str: string | null | undefined, allowed: string): string {
		if (str == null) return "";
		let r = "";
		for (let i = 0; i < str.length; i++) {
			let character = str.charAt(i);
			if (allowed.indexOf(character) >= 0) r = r + character;
		}
		return r;
	},

	/**
	 * Remove diacritics from a string
	 * @param str - Input string with diacritics
	 * @returns String with diacritics removed
	 */
	removeDiacritics(str: string): string {
		return str.normalize("NFD").replace(/\p{Diacritic}/gu, "");
	},

	/**
	 * Make URL-friendly text from given string
	 * @param text - Input text to convert to URL slug
	 * @returns URL-friendly string
	 */
	urlSlug(text: string): string {
		let str = StrUtil.removeDiacritics(text).trim().toLowerCase();
		return str.replace(/[^\/\w.]/g, "-");
	}
};

// Extend global window interface to include StrUtil
declare global {
	interface Window {
		StrUtil: typeof StrUtil;
	}
}

// Expose as global
window.StrUtil = StrUtil;

export default StrUtil;
